import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Input } from '../../components';
import SEO from '../../components/common/SEO';
import { requestPasswordReset } from './AuthRecovery.helper';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      const result = await requestPasswordReset(email);
      setMessage(result.message);
    } catch (err) {
      setError(err.message || 'Unable to process your request.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="lh-forgot-password min-h-screen bg-gradient-to-br from-dark-50 via-white to-primary-50 flex items-center justify-center p-4">
      <SEO title="Forgot Password" canonicalPath="/forgot-password" noIndex />
      <section className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <img src="/lat-icon.png" alt="Lotus Arc Technologies" className="h-14 w-auto" />
          <span className="text-2xl font-bold text-dark-900">LAT</span>
        </Link>
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h1 className="text-2xl font-bold text-dark-900 text-center mb-2">Reset your password</h1>
          <p className="text-dark-500 text-center mb-7">Enter your account email and we’ll send a secure reset link.</p>
          {message ? (
            <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm">
              {message}
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              {error && <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg text-sm">{error}</div>}
              <Input
                label="Email Address"
                type="email"
                name="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="you@example.com"
                required
              />
              <Button type="submit" variant="primary" fullWidth loading={loading}>Send reset link</Button>
            </form>
          )}
          <Link to="/login" className="block text-center mt-6 text-sm text-primary-500 hover:text-primary-600 font-medium">
            Back to sign in
          </Link>
        </div>
      </section>
    </main>
  );
};

export default ForgotPassword;
